import { gql } from '@apollo/client'
import { buildGraphqlQuery } from '@ztechapps/common.utils'

export const appSettingsTemplatesFavoriteMutationQuery = gql`
  mutation appSettings_UpdateTemplatesFavorite($input: UpdateTemplatesFavoriteServiceArgs!) {
    appSettings_UpdateTemplatesFavorite(input: $input) {
      _id
      value
    }
  }
`
export const appSettingQuery = buildGraphqlQuery('AppSetting', `_id value`)
